import { Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { COLOR_OPTIONS, accentHex } from "@/lib/constants";
import { cn } from "@/lib/utils";

export function MemberDialog({ open, onOpenChange, editing, form, setForm, onSave, onDelete }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-3xl">
        <DialogHeader>
          <DialogTitle className="font-display">{editing ? "Edit member" : "Add family member"}</DialogTitle>
          <DialogDescription className="sr-only">Family member details</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="space-y-1.5">
            <Label>Name</Label>
            <Input
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              placeholder="Ava"
              className="rounded-xl"
              data-testid="member-name-input"
            />
          </div>
          <div className="space-y-1.5">
            <Label>Role</Label>
            <div className="flex gap-2">
              {["parent", "kid"].map((r) => (
                <button
                  key={r}
                  type="button"
                  onClick={() => setForm({ ...form, role: r })}
                  data-testid={`member-role-${r}`}
                  className={cn(
                    "flex-1 rounded-xl py-2 text-sm font-semibold capitalize transition-colors",
                    form.role === r ? "bg-primary text-primary-foreground" : "bg-secondary text-secondary-foreground"
                  )}
                >
                  {r}
                </button>
              ))}
            </div>
          </div>
          <div className="space-y-1.5">
            <Label>Color</Label>
            <div className="flex flex-wrap gap-2">
              {COLOR_OPTIONS.map((c) => (
                <button
                  key={c}
                  type="button"
                  onClick={() => setForm({ ...form, color: c })}
                  data-testid={`member-color-${c}`}
                  className={cn(
                    "h-9 w-9 rounded-full transition-transform",
                    form.color === c ? "scale-110 ring-2 ring-offset-2 ring-ink" : ""
                  )}
                  style={{ backgroundColor: accentHex(c) }}
                />
              ))}
            </div>
          </div>
        </div>
        <DialogFooter className="flex-row justify-between gap-2 sm:justify-between">
          {editing ? (
            <Button variant="ghost" className="rounded-xl text-destructive" onClick={onDelete} data-testid="member-delete-btn">
              <Trash2 className="mr-1.5 h-4 w-4" /> Remove
            </Button>
          ) : (
            <span />
          )}
          <Button className="rounded-xl" onClick={onSave} data-testid="member-save-btn">
            Save
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
